// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ContatosFidelizacao_SaveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /contatos_fidelizacao/save
 *
 * Returns the created or updated loyalty contact (contato_fidelizacao) record.
 *
 * Properties:
 * - contatofidelizacao_id: Contact ID (newly created on insert)
 * - contatofidelizacao_data_cadastro: Creation timestamp (DATETIME, GMT-3 in DB)
 * - contatofidelizacao_franquia_id: Franchise ID
 * - contatofidelizacao_franquia_nome: Franchise name
 * - contatofidelizacao_cliente_id: Customer ID
 * - contatofidelizacao_owner: Owner type (e.g., "funcionario", "sistema")
 * - contatofidelizacao_owner_id: Owner identifier
 * - contatofidelizacao_content: Contact content/message
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ContatosFidelizacao_SaveResponseDados {
contatofidelizacao_id?: number
contatofidelizacao_data_cadastro?: string
contatofidelizacao_franquia_id?: number
contatofidelizacao_franquia_nome?: string
contatofidelizacao_cliente_id?: number
contatofidelizacao_owner?: string
contatofidelizacao_owner_id?: string
contatofidelizacao_content?: string
}

export type ContatosFidelizacao_SaveResponse = ApiResponse<ContatosFidelizacao_SaveResponseDados>;

registerResponseContract('ContatosFidelizacao_SaveResponse', {
  contatofidelizacao_id:            { type: 'number',  required: false },
  contatofidelizacao_data_cadastro: { type: 'string',  required: false },
  contatofidelizacao_franquia_id:   { type: 'number',  required: false },
  contatofidelizacao_franquia_nome: { type: 'string',  required: false },
  contatofidelizacao_cliente_id:    { type: 'number',  required: false },
  contatofidelizacao_owner:         { type: 'string',  required: false },
  contatofidelizacao_owner_id:      { type: 'string',  required: false },
  contatofidelizacao_content:       { type: 'string',  required: false },
})
